<template>
    <div class="container_content">
        <div class="tree">
            <treeMenu
                treeWidth="250px"
                style="width: 100%"
                ref="treeMenu"
                initId="0"
                :isEdit="true"
                loadStyle="staticLoad"
                @nodeClick="nodeId"
                :showBox="false"
            ></treeMenu>
        </div>
        <div class="main">
            <div class="M_search" style="justify-content:flex-end">
                <div class="rightBtn">
                    <el-button
                        style="float: right"
                        type="primary"
                        @click="dowTemplate"
                        icon="el-icon-document"
                        v-if="userData.routerData.includes('sys_dept_add') || isAdmin"
                    >模板
                    </el-button>
                    <el-button
                        style="float: right"
                        type="primary"
                        @click="uploading"
                        icon="el-icon-top"
                        v-if="userData.routerData.includes('sys_dept_add') || isAdmin"
                    >导入
                    </el-button>
                    <el-button
                        style="float: right"
                        type="primary"
                        @click="downloadExcel"
                        icon="el-icon-bottom"
                        v-if="userData.routerData.includes('sys_dept_exp') || isAdmin"
                    >导出
                    </el-button>

                    <el-button
                        icon="el-icon-plus"
                        type="success"
                        @click="openAdd('add')"
                        size="small"
                        style="float: right"
                        v-if="userData.routerData.includes('sys_dept_add') || isAdmin"
                    >新 增
                    </el-button>
                    <!-- <el-button
                            style="float: right"
                            size="small "
                            type="danger"
                            @click="deleteOptions()"
                            icon="el-icon-delete"
                            :disabled="isdisabled"
                    ><span>删除</span>
                    </el-button> -->
                </div>
            </div>
            <div class="tableHeight2" style="margin-top: 0">
                <el-table
                        v-loading="tableLoading"
                        :data="deptData.data"
                        stripe
                        height="100%"
                        style="min-width: 100%;min-height: 100%"
                        @select="handleSelectionChange"
                        tooltip-effect="dark"
                        header-row-class-name="table-head"
                        ref="deptTable"
                >
                    <!-- <el-table-column
                            type="selection"
                            width="55"
                            align="center"
                    ></el-table-column> -->
                    <el-table-column
                            type="index"
                            label="序号"
                            width="65"
                            align="center"
                    ></el-table-column>

                    <el-table-column
                            prop="name"
                            align="center"
                            label="部门名称"
                            show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                            prop="deptCode"
                            align="center"
                            label="部门编码"
                            show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                            align="center"
                            label="上级部门"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span>{{ searchParentName(scope.row.parentId) }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                            align="center"
                            label="教学单位"
                            width="100"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.organType == 1">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="机构层级"
                            width="100"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.organLevel == 1">校级</span>
                            <span v-if="scope.row.organLevel == 2">院级</span>
                            <span v-if="scope.row.organLevel == 3">专业</span>
                            <span v-if="scope.row.organLevel == 4">班级</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            width="100"
                            label="是否诊改"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.joinHie == 1">是</span>
                            <span v-else>否</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="160" align="center">
                        <template slot-scope="scope">
                            <el-button
                            type="text"
                            @click="openEdit(scope.row)"
                            v-if="userData.routerData.includes('sys_dept_edit') || isAdmin"
                            >编辑
                            </el-button>
                            <el-button
                                    type="text"
                                    @click="transferFn(scope.row)"
                                    v-if="userData.routerData.includes('sys_dept_del') || isAdmin"
                            >转移</el-button>
                            <el-button
                            type="text"
                            style="color: red"
                            @click="remove(scope.row)"
                            :disabled="subDisabled"
                            v-if="userData.routerData.includes('sys_dept_del') || isAdmin"
                            >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageDiv">
                <el-pagination
                        background
                        @current-change="changePage"
                        @size-change="handleSizeChange"
                        :current-page="initPage.current"
                        :page-sizes="initPage.sizes"
                        :page-size="initPage.size"
                        layout="total,sizes, prev, pager, next"
                        :total="deptData.total"
                >
                </el-pagination>
            </div>
        </div>
        <dept-add ref="addModal" :addData="addData" @closeAdd="closeAdd"></dept-add>
        <dept-edit
                ref="editModal"
                :editData="editData"
                @closeEdit="closeEdit"
        ></dept-edit>
        <importExcel
                ref="uplodModal"
                :uplodData="uplodData"
                @closeUplod="closeUplod"
        ></importExcel>
        <el-dialog
                :close-on-click-modal="false"
                title="组织关系转移"
                :visible.sync="delDeptShow"
                width="600px" >
            <div>
                <div class="remark">
                    将该组织下的账号、岗位、权责、填报、服务、标签、通知公告相关资源转移到已新建的新组织机构下。
                </div>
                <div class="select-dept-form">
                    <el-form label-width="150px" ref="delDeptForm"  :model="delDeptForm" :rules="delDeptFormRules" >
                            <el-form-item label="选择转入的组织名称" prop="targetDepartmentId">
                                <TreeSelect size="small"
                                            v-if="delDeptShow"
                                            :data="departmentData"
                                            clearable
                                            expandAll
                                            ref="deptSingle"
                                            :obj="mapKey"
                                            checkStrictly
                                            @getValue="setDeptSingleMenu">
                                </TreeSelect>
                            </el-form-item>
                    </el-form>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="delDeptFn('delDeptForm')" type="primary">确 定</el-button>
                <el-button @click="delDeptShow = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        fetchDeptList,
        saveDepartCharge,
        deleteDept,
        getDepartCharge,
    } from "@/api/management/dept";
    import treeMenu from "@/components/treeMenu/index.vue";
    import deptAdd from "@/components/dialog/deptManage/addList"; //添加
    import deptEdit from "@/components/dialog/deptManage/editList"; //编辑
    import importExcel from "@/components/dialog/deptManage/importExcel.vue";
    import {excelExport} from '@/api/importAndExport/excelApi';
    import {mapGetters} from "vuex";
    import TreeSelect from "@/components/TreeSelect.vue";
    import { getDeptTree,moveDept} from '@/api/managementCenter/otherApi';
    export default {
        name: "depManage",
        components: {treeMenu, deptAdd, deptEdit, importExcel,TreeSelect},
        data() {
            return {
                tableLoading: false,
                subDisabled: false,
                delDeptShow:false,
                delDeptName:'',
                delDeptForm:{
                    targetDepartmentId:null,
                    sourceDepartmentId:null
               },
                delDeptFormRules: {
                    targetDepartmentId: [
                        { required: true, message: "请选择部门", trigger: "blur" }
                    ]
                },
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                departmentData:[],
                filterText: "",
                searchName: {
                    username: "",
                    name: ""
                },
                deptData: {
                    data: [],
                    total: 0
                },
                initPage: {current: 0, size: 10, sizes: [10, 20, 50, 100]},
                treeSelect: [],
                addData: {
                    state: false,
                    data: null
                },
                editData: {
                    state: false,
                    data: null
                },
                personData: {
                    userData: null,
                    state: false,
                    data: null
                },
                uplodData: {
                    state: false,
                    type: ""
                },
                multipleSelection: [],
                selectedId: '',
                currenTreeId: null,
            };
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            }
        },
        computed: {
            ...mapGetters([
                "userData",
            ]),
            isdisabled() {
                return this.multipleSelection.length > 0 ? false : true;
            }
        },
        created: function () {
            //显示所有部门
            this.refreshDepartment();
        },
        mounted: function () {
            this.treeData = this.$store.getters.chooseDept;
        },
        methods: {
            isAdmin(){
                return (this.userData.roleCodes||[]).includes('ROLE_ADMIN')
            },
            downloadExcel(){
                this.$DownLoad(
                    excelExport('organ'),
                    null,
                    res => {
                        if (res.status == 200) {
                            // this.$message.success("开始下载");
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
            cellClass(row){
                if (row.columnIndex === 0) {
                    return 'disabledCheck'
                }
            },
            handleSelectionChange(selection, row) {
                // this.multipleSelection = selection;
                this.selectedId = selection.length > 0 ? row.deptId : '';
                this.$refs.deptTable.clearSelection();
                if(selection.length > 0) this.$refs.deptTable.toggleRowSelection(row);
            },
            /**
             * @description: 批量删除
             * @param:{obj}
             * @return:
             */
            deleteOptions(row) {
                if (this.selectedId) {
                    this.$confirm(
                        "点击“确定”按钮删除选中内容，否则请点击“取消”按钮！",
                        "信息消息",
                        {
                            confirmButtonText: "确定",
                            cancelButtonText: "关闭",
                            type: "warning"
                        }
                    ).then(() => {
                        // const idArr = this.multipleSelection.map(item => {
                        //     return item.deptId;
                        // });
                        deleteDept(selectedId)
                            .then(res => {
                                if (res.data.code == 0) {
                                    this.$message.success("删除成功");
                                    // if (
                                    //     this.deptData.data.length === idArr.length &&
                                    //     this.initPage.current > 1
                                    // ) {
                                    //     this.deptData.total -= 1;
                                    //     this.initPage.current -= 1;
                                    // }
                                    this.refreshDepartment(
                                        this.initPage.size,
                                        this.initPage.current,
                                        this.currenTreeId
                                    );
                                } else {
                                    this.$message.closeAll();
                                    this.$message.error(res.data.msg);
                                }
                            })
                            .catch(err => {
                                this.$message.closeAll();
                                this.$message.error("删除失败");
                            });
                    });
                } else {
                    this.$message.closeAll();
                    this.$message.warning("请选择目标项");
                }
            },
            /**
             * @description: 删除
             * @param:{obj}
             * @return:
             */
            remove(row) {
                let that = this;
                let data = this.searchTreeData(row.deptId);
                if (data.children.length > 0) {
                    this.$alert("还存在着子部门，请先删除子部门！", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                } else {
                    this.$confirm("确定删除该部门?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                        .then(() => {
                            this.subDisabled = true;
                            deleteDept(row.deptId)
                                .then(res => {
                                    if (res.data.code == 0) {
                                        this.subDisabled = false;
                                        // 重新获取组织部门树
                                        that.$store.dispatch("getDeptTree").then(data => {
                                            that.$store.commit("SET_CHOOSE_DEPT", data.data.data);
                                            that.refreshDepartment(
                                                this.initPage.size,
                                                this.initPage.current,
                                                this.treeSelect != null ? this.treeSelect.id : null
                                            );
                                        });
                                    } else {
                                        this.subDisabled = false;
                                        this.$alert(res.data.msg, "提示", {
                                            confirmButtonText: "确定",
                                            type: "warning"
                                        });
                                    }
                                })
                                .catch(() => {
                                });
                        })
                        .catch(() => {
                        });
                }
            },
            transferFn(row) {
                this.delDeptShow=true;
                this.delDeptForm.sourceDepartmentId=row.deptId;
                this.delDeptName=row.name;
                this.getDeptTreeData(row.deptId)
            },

            setDeptSingleMenu(key,data){//获取子组件值
                this.delDeptForm.targetDepartmentId = data.id;
            },
            delDeptFn(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.moveDeptHttp()
                    } else {
                        return false;
                    }
                });
            },
            moveDeptHttp(){
                moveDept( this.delDeptForm).then(({data})=>{
                    if(data.code == 0){
                     this.delDeptShow=false;
                     this.$message.success(data.msg||'操作成功！')
                        this.$store.dispatch("getDeptTree").then(data => {
                            this.$store.commit("SET_CHOOSE_DEPT", data.data.data);
                            this.refreshDepartment(
                                this.initPage.size,
                                this.initPage.current,
                                this.treeSelect != null ? this.treeSelect.id : null
                            );
                        });
                    }else{
                        this.$message.warning(data.msg||'删除失败！')
                    }
                }).catch(err=>{
                    this.$message.error('删除异常！')
                })

            },
            getDeptTreeData(filterDeptId){
                getDeptTree({filterDeptId}).then(({data})=>{
                    if(data.code == 0){
                        this.departmentData = data.data
                    }
                }).catch(err=>{

                })

            },

            /**
             * @description: 关闭新增
             * @param:{obj}
             * @return:
             */
            closeAdd(obj) {
                this.addData.state = false;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    this.treeSelect != null ? this.treeSelect.id : null
                );
            },
            /**
             * @description: 新增
             * @param:{}
             * @return:
             */
            openAdd() {
                if (this.treeSelect.length < 1) {
                    this.$alert("请先选择左侧一个部门作为上级部门", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                } else {
                    this.addData.data = this.treeSelect;
                    this.$refs.addModal.showAddData();
                    this.addData.state = true;
                }
            },
            // 下载模板
            dowTemplate() {
                this.$DownLoad(
                    "/admin/excel/download?type=organ",
                    null,
                    res => {
                        if (res.status == 200) {
                            // this.$message.success("开始下载");
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );
            },
            uploading() {
                this.uplodData.state = true;
                this.uplodData.type = "organ";
            },
            closeUplod(val) {
                this.uplodData.state = val;
                // this.refreshDepartment(
                //     this.initPage.size,
                //     this.initPage.current,
                //     this.treeSelect != null ? this.treeSelect.id : null
                // );
                this.$store.dispatch("getDeptTree").then((data) => {
                    this.$store.commit("SET_CHOOSE_DEPT",data.data.data)
                });
            },
            /**
             * @description: 关闭编辑
             * @param:{obj}
             * @return:
             */
            closeEdit(obj) {
                this.editData.state = false;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    this.treeSelect != null ? this.treeSelect.id : null
                );
            },
            /**
             * @description: 关闭负责人
             * @param:{obj}
             * @return:
             */
            closePerson(obj) {
                for (let i = 0; i < obj.data.length; i++) {
                    if (isNaN(obj.data[i])) {
                        obj.data.splice(i, 1);
                    }
                }
                let queryObj = {
                    deptId: this.personData.data.deptId,
                    charges: obj.data != [] ? obj.data.toString() : null
                };
                saveDepartCharge(queryObj).then(res => {
                    if (res.data.code == 0) {
                        // this.$message.success("操作成功")
                    } else {
                        this.$alert(res.data.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                });
                this.personData.state = false;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    this.treeSelect != null ? this.treeSelect.id : null
                );
            },
            /**
             * @description: 打开负责人
             * @param:{}
             * @return:
             */
            openPerson(row) {
                this.personData.data = row;
                getDepartCharge({deptId: this.personData.data.deptId}).then(res => {
                    if (res.data.code == 0) {
                        let data = res.data.data.split(","); // 在每个逗号(,)处进行分解  ["abc", "abcd", "aaa"]
                        for (let i = 0; i < data.length; i++) {
                            data[i] = parseInt(data[i]);
                        }
                        this.personData.userData = data;
                        this.$refs.personModal.loadData();
                        this.personData.state = true;
                    } else {
                        this.$alert(res.data.msg, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                });
            },
            /**
             * @description: 编辑
             * @param:{}
             * @return:
             */
            openEdit(row) {
                this.editData.data = row;
                this.$refs.editModal.showEditData();
                this.editData.state = true;
            },
            /**
             * @description: 上级部门
             * @param:{pagesize, pageindex, deptId}
             * @return:
             */
            searchParentName(parentId) {
                let parentName;
                let searchParentName = function (searchdata, searchpid) {
                    searchdata.forEach(e => {
                        if (e.id == searchpid) {
                            parentName = e.name;
                            return;
                        } else {
                            if (e.children.length > 0) {
                                searchParentName(e.children, searchpid);
                            }
                        }
                    });
                };
                searchParentName(this.$store.getters.chooseDept, parentId);
                return parentName;
            },
            /**
             * @description: tree根据id找当前那条数据
             * @param:{id}
             * @return:
             */
            searchTreeData(id) {
                let treeData;
                let searchParentName = function (searchdata, searchpid) {
                    searchdata.forEach(e => {
                        if (e.id == searchpid) {
                            treeData = e;
                            return;
                        } else {
                            if (e.children.length > 0) {
                                searchParentName(e.children, searchpid);
                            }
                        }
                    });
                };
                searchParentName(this.$store.getters.chooseDept, id);
                return treeData;
            },
            /**
             * @description: 显示所有部门数据
             * @param:{pagesize, pageindex, deptId}
             * @return:
             */
            refreshDepartment(pagesize, pageindex, deptId) {
                this.tableLoading = true;
                let queryObj = {
                    current: pageindex ? pageindex : this.initPage.current,
                    size: pagesize ? pagesize : this.initPage.size,
                    pid: deptId ? deptId : "1"
                };
                fetchDeptList(queryObj).then(res => {
                    this.deptData.data = res.data.data.records;
                    this.deptData.total = res.data.data.total;
                    this.tableLoading = false;
                });
            },
            /**
             * @description: 分页
             * @param:{num}
             * @return:
             */
            changePage(num) {
                this.initPage.current = num;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    this.treeSelect != null ? this.treeSelect.id : null
                );
            },
            /**
             * @description: 选择条数
             * @param:{num}
             * @return:
             */
            handleSizeChange(val) {
                this.initPage.size = val;
                this.initPage.current = 1;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    this.treeSelect != null ? this.treeSelect.id : null
                );
            },
            /**
             * @description: 点击tree
             * @param:{dataId}
             * @return:
             */
            nodeId(data) {
                this.treeSelect = data;
                this.initPage.current = 1;
                this.initPage.size = 10;
                this.currenTreeId = data.id;
                this.refreshDepartment(
                    this.initPage.size,
                    this.initPage.current,
                    data.id
                );
            }
        },
        watch:{
            delDeptShow(value){
                if(!value){
                    this.delDeptForm={
                        targetDepartmentId:null,
                         sourceDepartmentId:null
                    };
                }

            }
        }

    };
</script>

<style lang='less' scoped>
    .container_content {
        display: flex;
        justify-content: space-between;

        .tree {
            max-width: 280px;
            width: auto;
        }

        .main {
            flex: 1;
            min-width: calc(100% - 280px);
        }
    }
    /* 去掉全选按钮 */
    .el-table /deep/.disabledCheck .cell .el-checkbox__inner{
        display:none;
        position:relative;
    }
    .el-table /deep/.disabledCheck .cell:before{
        content:"选择";
        position:absolute;
        right: 11px;
    }
    .select-dept-form{
        padding-bottom: 10px;
    }
    .remark{
        font-size: 14px;
        color: #606266;
        line-height: 26px;
        text-align: left;
        text-indent: 28px;
        padding: 30px 0;
    }
</style>
